import React, { useState } from "react";
import { styled } from "styled-components";
import { DropdownMenu, DropdownMenuItem, DropdownToggle, StyledLanguageSelector, } from "./style";
import FlagSquareNorway from "../../../../flags/FlagSquareNorway";
import FlagSquareDenmark from "../../../../flags/FlagSquareDenmark";
import FlagSquareGermany from "../../../../flags/FlagSquareGermany";
import FlagSquareUK from "../../../../flags/FlagSquareUK";
import FlagSquareNetherlands from "../../../../flags/FlagSquareNetherlands";
import FlagSquareSweden from "../../../../flags/FlagSquareSweden";
import { ClickArea, CurrentLocale, Grow, LogoutOnlyWrapper, LogoutWrapper, PaddingRight, SelectorWrapper, SpaceBetween, } from "../Sidebar/style";
import { ChevronDown, ChevronUp, Logout2 } from "../../../../icons";
import { Button } from "../../../Button";
import Colors from "../../../../styles/Colors";
const LanguageText = styled.span `
  color: ${({ textColor }) => textColor || Colors.BLACK_2024};
`;
const locales = ["da", "se", "nl", "en", "de", "nb"];
const getFlagComponent = (locale) => {
    switch (locale) {
        case "nb":
            return FlagSquareNorway;
        case "da":
            return FlagSquareDenmark;
        case "de":
            return FlagSquareGermany;
        case "en":
            return FlagSquareUK;
        case "nl":
            return FlagSquareNetherlands;
        case "se":
            return FlagSquareSweden;
        default:
            return FlagSquareNorway;
    }
};
const LanguageSelector = ({ currentLocale, dropBelow, dropDownWidth, locales: selectorLocales, noLeftPadding, onLocaleChange, onLogout, textColor, blackFridayTheme, }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const CurrentFlagIcon = currentLocale
        ? getFlagComponent(currentLocale)
        : undefined;
    const handleLocaleChange = (locale) => {
        setShowDropdown(false);
        if (onLocaleChange) {
            onLocaleChange(locale);
        }
    };
    const handleToggleDropdown = (e) => {
        e.preventDefault();
        setShowDropdown(!showDropdown);
    };
    return (React.createElement(StyledLanguageSelector, null,
        !currentLocale && !selectorLocales && onLogout && (React.createElement(LogoutOnlyWrapper, null,
            React.createElement(Button, { dataCy: "btn-logout", style: { background: "transparent", padding: 0 }, onClick: () => onLogout(), size: "small", "data-cy": "logout-btn", theme: "clean", dashedBorder: true, "alt-text": "Log out" },
                React.createElement(Logout2, { width: 20, height: 20, color: "PROFILE_RED_2024" })))),
        CurrentFlagIcon && currentLocale && selectorLocales ? (React.createElement(React.Fragment, null,
            React.createElement(SelectorWrapper, null,
                React.createElement(DropdownToggle, { role: "button", "data-toggle": "dropdown", "aria-haspopup": "true", id: "languageSwitch", "aria-expanded": showDropdown ? "true" : "false", noLeftPadding: noLeftPadding },
                    React.createElement("span", null,
                        React.createElement(Grow, null,
                            React.createElement(ClickArea, { onClick: handleToggleDropdown },
                                React.createElement(PaddingRight, { paddingRight: 1 },
                                    React.createElement(CurrentFlagIcon, { width: 25, height: 25 })),
                                React.createElement(SpaceBetween, null,
                                    React.createElement(CurrentLocale, null,
                                        React.createElement(LanguageText, { textColor: textColor }, selectorLocales[currentLocale])),
                                    React.createElement(LanguageText, { textColor: textColor }, showDropdown ? (React.createElement(ChevronUp, { width: 16 })) : (React.createElement(ChevronDown, { width: 16 })))))))),
                onLogout ? (React.createElement(LogoutWrapper, null,
                    React.createElement(Button, { dataCy: "btn-logout", style: { background: "transparent", padding: 0 }, onClick: () => onLogout(), size: "small", "data-cy": "logout-btn", theme: "clean", dashedBorder: true, "alt-text": "Log out" },
                        React.createElement(Logout2, { width: 20, height: 20, color: blackFridayTheme ? "WHITE_2024" : "BLACK_2024" })))) : null),
            showDropdown && (React.createElement(DropdownMenu, { className: "dropdown-menu sidebar-lang__list", role: "menu", dropBelow: dropBelow, dropDownWidth: dropDownWidth }, Object.keys(selectorLocales).map((localeKey) => {
                const FlagIcon = getFlagComponent(localeKey);
                const localeTitle = selectorLocales[localeKey];
                return (React.createElement(DropdownMenuItem, { key: localeKey },
                    React.createElement("button", { type: "button", onClick: () => handleLocaleChange(localeKey) },
                        React.createElement(FlagIcon, { width: 25, height: 25 }),
                        React.createElement("span", null, localeTitle))));
            }))))) : null));
};
export default LanguageSelector;
//# sourceMappingURL=index.js.map